var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "gallery-view gallery-view--insect-v2" },
    [
      _c("gallery-view-toolbar", {
        attrs: {
          editable: _vm.editable,
          event: _vm.event,
          sensorType: _vm.sensorType,
          canDownload: _vm.canDownload,
          title: _vm.title,
        },
        on: {
          download: _vm.download,
          update: function (attr) {
            return _vm.$emit("updateEvent", attr)
          },
          close: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "layout",
        {
          attrs: { hasPrevious: _vm.hasPrevious, hasNext: _vm.hasNext },
          on: {
            previous: function ($event) {
              return _vm.$emit("previous")
            },
            next: function ($event) {
              return _vm.$emit("next")
            },
          },
          scopedSlots: _vm._u([
            {
              key: "top",
              fn: function () {
                return [
                  _c("gallery-view-header", {
                    attrs: { editable: _vm.editable, event: _vm.event },
                    on: {
                      updateEvent: function ($event) {
                        return _vm.$emit("updateEvent", $event)
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "side",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "result-table pa-2" },
                    [
                      _c("v-checkbox", {
                        staticClass: "pa-0 mb-3",
                        attrs: {
                          label: _vm.$t("field.original"),
                          "hide-details": "",
                          color: "primary",
                        },
                        model: {
                          value: _vm.viewOriginal,
                          callback: function ($$v) {
                            _vm.viewOriginal = $$v
                          },
                          expression: "viewOriginal",
                        },
                      }),
                      _vm._v(" "),
                      _c("insect-count-table", {
                        attrs: {
                          insectCounts: _vm.event.insect_counts,
                          showRadiobutton:
                            _vm.canPickDetectionType && !_vm.imageLoading,
                          pickedDetectionType: _vm.pickedDetectionType,
                        },
                        on: {
                          "update:pickedDetectionType": function ($event) {
                            _vm.pickedDetectionType = $event
                          },
                          "update:picked-detection-type": function ($event) {
                            _vm.pickedDetectionType = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-carousel",
                {
                  attrs: { touchless: "", height: null },
                  model: {
                    value: _vm.index,
                    callback: function ($$v) {
                      _vm.index = $$v
                    },
                    expression: "index",
                  },
                },
                _vm._l(_vm.images, function (image) {
                  return _c(
                    "v-carousel-item",
                    { key: image.id, attrs: { eager: "" } },
                    [
                      _c(
                        "picked-insects-draw",
                        {
                          attrs: {
                            imageSrc: _vm.event.attachments[image],
                            pickedDetectionType: _vm.pickedDetectionType,
                            currentPhotoKey: _vm.editTarget,
                            event: _vm.event,
                            hideCanvas: _vm.hideCanvas,
                          },
                        },
                        [
                          _c("loading-image", {
                            attrs: {
                              src: _vm.event.attachments[image],
                              forceLoading: _vm.imageLoading,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm._t("thumbnails"),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }